import DOMPurify from "dompurify"

const allowedOrigins = [
  "https://www.google-analytics.com",
  "https://region1.google-analytics.com",
  "https://www.googletagmanager.com",
  "https://cdn.us.heap-api.com",
]

const allowedDomains = [
  ".cloudsinc.net",
  ".kaizenreporting.com",
  ".londonreportinghouse.com",
]

const inoffensiveScript = `(function anonymous(
) {
"use strict"; return (function* () {}).constructor;
})`

if (window.trustedTypes && window.trustedTypes.createPolicy) {
  window.trustedTypes.createPolicy("default", {
    createHTML: (string) =>
      DOMPurify.sanitize(string, {
        RETURN_TRUSTED_TYPE: true,
        ADD_TAGS: [
          "ag-page-size-selector",
          "ag-checkbox",
          "ag-input-text-field",
          "ag-sort-indicator",
        ],
      }),
    createScript: (string) => {
      if (string === inoffensiveScript) return string
      throw new TypeError("XSS not allowed")
    },
    createScriptURL: (url) => {
      const parsed = new URL(url, document.baseURI)
      if (parsed.origin === document.location.origin) return url
      if (allowedOrigins.includes(parsed.origin)) return url
      if (
        allowedDomains.some(
          (domain) =>
            parsed.protocol === "https:" && parsed.hostname.endsWith(domain)
        )
      )
        return url

      throw new TypeError("invalid URL")
    },
  })
}
